export const marketingTagsKeys = {
  all: ['marketing-tags'] as const,
  lists: () => [...marketingTagsKeys.all, 'list'] as const,
  list: (filters: string) => [...marketingTagsKeys.lists(), { filters }] as const,
};
